const DataDeletion = () => {
  return (
    <div className="p-8 max-w-3xl mx-auto text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">Data Deletion Request</h1>
      <p>
        If you want to delete your data associated with our WhatsApp chatbot, please contact us by email:
      </p>
      <p className="mt-4">
        <strong>Email:</strong>{' '}
        <a href="mailto:info@jrautomation.be" className="text-blue-600 hover:underline">
          info@jrautomation.be
        </a>
      </p>
      <p className="mt-4">
        We will process your request within 5 business days.
      </p>
    </div>
  );
};

export default DataDeletion;
